import PartSelectorBottom from 'components/PartSelector/PartSelectorBottom'
import SceneSideBar from 'components/SceneSideBar'
import { FC } from 'react'

import NavigateButton from 'components/NavigateButton'
import SceneTable from 'components/SceneTable'
import StartPage from 'components/StartPage'
import { useScene } from 'providers/SceneProvider'
import { useLocation } from 'react-router-dom'
import Scene from './components/Scene'

const App: FC = () => {
  const { showTable } = useScene()
  const { pathname } = useLocation()
  console.warn = () => {}
  if (pathname === '/') {
    return <StartPage />
  }

  if (!showTable) {
    return (
      <div className='flex flex-row justify-center items-center absolute inset-0 w-full h-full bg-gray-300'>
        <div className='relative w-full h-full overflow-hidden'>
          <NavigateButton />
          <Scene />
          <PartSelectorBottom />
        </div>
        <SceneSideBar className='hidden md:flex' />
      </div>
    )
  } else {
    return (
      <div className='flex flex-row justify-center items-center absolute inset-0 w-full h-full bg-[#F3F4F6]'>
        <NavigateButton />
        <div className='relative w-full overflow-auto h-full'>
          <div className='flex justify-center my-20 '>
            <SceneTable />
          </div>
        </div>
      </div>
    )
  }
}

export default App
